export default "__VITE_ASSET__7wyHsi$___"